(()=>{
  'use strict';
  const bar=document.getElementById('raaw-exchange-demo-bar');
  if(!bar)return;
  const query=new URLSearchParams(location.search);
  try{
    if(query.get('raaw_return_origin')==='portal')sessionStorage.setItem('raaw.exchange.portal.origin','https://retur.raaw51.shop');
    if(query.get('raaw_exchange')==='demo')sessionStorage.setItem('raaw.exchange.demo.active','1');
    if(sessionStorage.getItem('raaw.exchange.demo.active')!=='1')return;
  }catch{return;}
  const returnUrl='https://retur.raaw51.shop/';
  const portalMode=sessionStorage.getItem('raaw.exchange.portal.origin')==='https://retur.raaw51.shop';
  if(portalMode){const back=bar.querySelector('a');if(back){back.href='https://retur.raaw51.shop/';back.addEventListener('click',e=>{if(window.opener){e.preventDefault();window.opener.focus();window.close();}});}}
  bar.hidden=false;
  document.body.classList.add('raaw-exchange-demo-active');
  let overlayFrame=0;
  const visibleConsent=()=>['shopify-pc__banner','shopify-pc__prefs'].some(id=>{
    const element=document.getElementById(id);
    if(!element||element.hidden||element.getAttribute('aria-hidden')==='true')return false;
    const style=getComputedStyle(element);
    return style.display!=='none'&&style.visibility!=='hidden'&&element.getClientRects().length>0;
  });
  const updateOverlays=()=>{
    overlayFrame=0;
    const consentOpen=visibleConsent();
    document.body.classList.toggle('raaw-exchange-consent-open',consentOpen);
    const height=consentOpen?0:Math.ceil(bar.getBoundingClientRect().height);
    const value=height+'px';
    if(document.body.style.getPropertyValue('--raaw-exchange-bar-height')!==value)document.body.style.setProperty('--raaw-exchange-bar-height',value);
  };
  const scheduleOverlays=()=>{if(!overlayFrame)overlayFrame=requestAnimationFrame(updateOverlays);};
  new ResizeObserver(scheduleOverlays).observe(bar);
  new MutationObserver(scheduleOverlays).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
  window.addEventListener('resize',scheduleOverlays,{passive:true});
  window.visualViewport?.addEventListener('resize',scheduleOverlays,{passive:true});
  updateOverlays();
  const labels=JSON.parse(document.getElementById('raaw-exchange-demo-labels').textContent);
  document.getElementById('raaw-exchange-demo-stop').addEventListener('click',()=>{
    sessionStorage.removeItem('raaw.exchange.portal.origin');
    sessionStorage.removeItem('raaw.exchange.demo.active');
    sessionStorage.removeItem('raaw.exchange.demo.selection');
    sessionStorage.removeItem('raaw.exchange.demo.state');
    location.assign('/?preview_theme_id=');
  });
  document.addEventListener('submit',e=>{if(e.target.matches('form[action*="/cart/add"],form[action*="/cart"]')){e.preventDefault();e.stopImmediatePropagation();}},true);
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href]');
    if(!a)return;
    const u=new URL(a.href,location.origin);
    if(u.origin===location.origin&&/\/(cart|checkout)(\/|$)/.test(u.pathname)){e.preventDefault();return;}
    if(u.origin===location.origin&&!u.hash&&!u.searchParams.has('view')){u.searchParams.delete('preview_theme_id');a.href=u.href;}
  },true);
  const data=JSON.parse(document.getElementById('raaw-exchange-demo-product').textContent);
  if(!data)return;
  const select=document.getElementById('raaw-exchange-demo-variant');
  const choose=document.getElementById('raaw-exchange-demo-choose');
  const price=document.getElementById('raaw-exchange-demo-price');
  const error=document.getElementById('raaw-exchange-demo-error');
  const variants=data.product.variants||[];
  const formatter=new Intl.NumberFormat('da-DK',{style:'currency',currency:data.currency||'DKK'});
  for(const v of variants){const option=document.createElement('option');option.value=String(v.id);option.textContent=v.title+' · '+formatter.format(v.price/100)+(v.available?'':' · '+labels.unavailable);option.disabled=!v.available;select.append(option);}
  const first=variants.find(v=>v.available);
  if(first)select.value=String(first.id);
  const current=()=>variants.find(v=>String(v.id)===select.value);
  const update=()=>{const v=current();choose.disabled=!v||!v.available||data.giftCard||data.currency!=='DKK';price.textContent=v?formatter.format(v.price/100):labels.unavailable;if(data.giftCard)error.textContent=labels.giftcard;};
  select.addEventListener('change',update);update();
  choose.addEventListener('click',()=>{
    const v=current();if(!v||!v.available||data.giftCard||data.currency!=='DKK')return;
    try{
      const selected={id:String(v.id),title:data.product.title,variant:v.title,price:v.price,currency:data.currency,handle:data.product.handle};
      if(sessionStorage.getItem('raaw.exchange.portal.origin')==='https://retur.raaw51.shop'&&window.opener){window.opener.postMessage({type:'raaw.exchange.selection',selection:selected},'https://retur.raaw51.shop');window.close();return;}
      sessionStorage.setItem('raaw.exchange.demo.selection',JSON.stringify(selected));
      location.assign(returnUrl+'&raaw_return_selection=1');
    }catch{error.textContent=labels.storage_error;}
  });
})();
